import { useContext } from 'react';
import {
  NumberFormatProviderData,
  NumberFormatContext
} from './NumberFormatProvider';

export const useMeNumberFormats = (): NumberFormatProviderData =>
  useContext(NumberFormatContext) as NumberFormatProviderData;
